// extracted by mini-css-extract-plugin
export default {"container":"edit-compare-table-page_container__30DIy","title_wrapper":"edit-compare-table-page_title_wrapper__bKJt9"};